import { User } from '../types';

interface HeaderProps {
  user: User;
}

export default function Header({ user }: HeaderProps) {
  return (
    <header
      className="flex items-center justify-between px-4 py-3 bg-surface-card border-b border-white/5"
      style={{ paddingTop: 'max(12px, env(safe-area-inset-top))' }}
    >
      <div className="flex items-center gap-2">
        <div className="w-8 h-8 bg-gradient-to-br from-accent-purple to-accent-gold rounded-lg flex items-center justify-center text-sm font-bold shadow-lg">
          S
        </div>
        <div>
          <h1 className="text-white font-bold text-base leading-none">SlabVault</h1>
          <p className="text-gray-500 text-xs leading-none mt-0.5">
            @{user.tg_username ?? user.tg_name}
          </p>
        </div>
      </div>
      <button className="bg-accent-purple/20 text-accent-purple-light border border-accent-purple/30 text-xs font-semibold px-3 py-1.5 rounded-lg">
        Connect Wallet
      </button>
    </header>
  );
}
